module.exports = __webpack_public_path__ + "static/media/franz.3da64afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/franz.png
// module id = 1461
// module chunks = 0